<template src="../templates/normal_fcont_200.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import PrintButton from '../components/PrintButton'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadColorioNenga from '../components/AppDownloadColorioNenga'
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'
import { Carousel,Slide } from 'uiv'



export default {
  name: 'app',
  data() {
    return {
      articleId: '200',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,PrintButton,
    ReleaseDateForArticle,AppDownloadColorioNenga,AppDownloadPhotoPlusJp
  },
  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    },
  },
  methods: {
    trackGa4GoAppLine: function (launchType) {
      this.$gtag.event("go_app", {
        "app_name": "LINE Print",
        "article_no": this.articleId,
        "print_type": launchType,
        "site_id": "gallery"
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['200-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['200-3']}
      ]
    };
  }

};


</script>

<style >
</style>

